/**
 * AmbientLightComponent - non-directional illumination for the scene.
 * Lights all objects equally, does not cast shadows. Shadow methods are no-ops.
 */
import * as THREE from 'three';

import { EngineClass } from '../../systems/ClassRegistry.js';

import { LightComponent } from './LightComponent.js';

import type { LightComponentOptions } from './LightComponent.js';


export interface AmbientLightComponentOptions extends LightComponentOptions { }

/** Wraps a THREE.AmbientLight. */
@EngineClass('AmbientLightComponent')
export class AmbientLightComponent extends LightComponent<THREE.AmbientLight, AmbientLightComponentOptions> {

  protected override createLight(): THREE.AmbientLight {
    return new THREE.AmbientLight();
  }

  protected override configureShadow(): this {
    // Ambient lights don't cast shadows.
    return this;
  }

  protected override createLightHelper(): THREE.Object3D | null {
    return null;
  }

  //====================================================================================================
  // Editor Functions
  //====================================================================================================

  public override getEditorClassIcon(): string | null {
    return 'Icon_Ambient';
  }
}
